<template>
  <div class="wrapper" v-if="active_ingredients.length > 0">
    <div class="outer" @click="open = !open">
      <div class="inner">
        <svg
          v-if="open"
          xmlns="http://www.w3.org/2000/svg"
          height="20px"
          viewBox="0 -960 960 960"
          width="20px"
          fill="var(--component_IngredientGroupDisplay_ingredientGroupHeader_color)"
        >
          <path d="M186-416v-128h588v128H186Z" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          height="20px"
          viewBox="0 -960 960 960"
          width="20px"
          fill="var(--component_IngredientGroupDisplay_ingredientGroupHeader_color)"
        >
          <path
            d="M416-416H194v-128h222v-223h128v223h222v128H544v222H416v-222Z"
          />
        </svg>
      </div>
      <div class="ingredientGroupHeader">
        {{ ingredientGroupName(ingredientgroup) }}
      </div>
      <div class="ingredientGroupPrice">{{ totalPrice() }}</div>
    </div>
    <div class="ingredients" v-if="open">
      <div
        :key="ingredient.id"
        class="ingredient"
        v-for="ingredient in active_ingredients"
      >
        {{ name(ingredient) }}
        <span class="ingredientPrice">{{
          renderPrice(ingredient.totalPrice)
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  toCalculatable,
  toPrintable,
  ingredientPrice,
  annotatePricesIngredientGroup
} from "@/utils/pricing";
import { cssVarBoolean, getTranslation } from "@/utils/helpers";

export default {
  name: "IngredientGroupDisplay",
  computed: {
    active_ingredients() {
      let ing_items = annotatePricesIngredientGroup(
        this.product,
        this.ingredientgroup
      );
      return ing_items.filter(ing => ing.count !== 0);
    }
  },
  created() {
    this.open = this.ingredientsDefaultExpanded();
  },
  data() {
    return {
      open: true
    };
  },
  methods: {
    ingredientsDefaultExpanded() {
      return cssVarBoolean(
        "--component_IngredientGroupDisplay_ingredients_default_expanded"
      );
    },
    getTranslation,
    ingredientGroupName(ingredientgroup) {
      if (ingredientgroup.display_name !== "")
        return getTranslation(
          this.$store,
          "IngredientGroup",
          "display_name",
          ingredientgroup.id,
          ingredientgroup.display_name
        );
      return ingredientgroup.name;
    },
    price(ing) {
      let ing_price =
        toCalculatable(ing.price) * Math.max(1, ing.count - ing.default_count);
      if (ing.count === ing.default_count) ing_price = 0.0;
      return this.renderPrice(ing_price);
    },
    renderPrice(price) {
      if (price === 0.0) return "";
      return `(${toPrintable(price, true)})`;
    },
    name(ing) {
      let prefix = "";
      if (ing.count === 1) {
        prefix = "";
      } else {
        prefix = ing.count + "x ";
      }
      return (
        prefix +
        getTranslation(
          this.$store,
          "Ingredient",
          "display_name",
          ing.id,
          ing.name
        )
      );
    },
    totalPrice() {
      let ing_price = toCalculatable(
        ingredientPrice(this.product, this.ingredientgroup.id)
      );
      if (ing_price === 0.0) return "";
      return `(${toPrintable(ing_price, true)})`;
    }
  },
  props: {
    ingredientgroup: Object,
    product: Object
  }
};
</script>

<style scoped>
.wrapper {
  margin-top: 4px;
  color: var(--component_IngredientGroupDisplay_wrapper_color);
  font-family: var(--component_IngredientGroupDisplay_wrapper_font-family);
  font-size: var(--component_IngredientGroupDisplay_wrapper_font-size);
}
.ingredientGroupHeader {
  color: var(--component_IngredientGroupDisplay_ingredientGroupHeader_color);
  font-weight: var(
    --component_IngredientGroupDisplay_ingredientGroupHeader_font-weight
  );
  font-family: var(
    --component_IngredientGroupDisplay_ingredientGroupHeader_font-family
  );
  font-size: var(
    --component_IngredientGroupDisplay_ingredientGroupHeader_font-size
  );
  font-style: var(
    --component_IngredientGroupDisplay_ingredientGroupHeader_font-style
  );
  padding: var(
    --component_IngredientGroupDisplay_ingredientGroupHeader_padding
  );
  text-transform: var(
    --component_IngredientGroupDisplay_ingredientGroupHeader_text-transform
  );
}

.ingredientGroupPrice {
  color: var(--component_IngredientGroupDisplay_ingredientGroupPrice_color);
  font-family: var(
    --component_IngredientGroupDisplay_ingredientGroupPrice_font-family
  );
  font-size: var(
    --component_IngredientGroupDisplay_ingredientGroupPrice_font-size
  );
  font-style: var(
    --component_IngredientGroupDisplay_ingredientGroupPrice_font-style
  );
  font-weight: var(
    --component_IngredientGroupDisplay_ingredientGroupPrice_font-weight
  );
  margin: var(--component_IngredientGroupDisplay_ingredientGroupPrice_margin);
}

.ingredients {
  margin: var(--component_IngredientGroupDisplay_ingredients_margin);
  font-family: var(--component_IngredientGroupDisplay_ingredients_font-family);
  font-size: var(--component_IngredientGroupDisplay_ingredients_font-size);
}
.inner {
  font-family: var(--component_IngredientGroupDisplay_inner_font-family);
  color: var(--component_IngredientGroupDisplay_inner_color);
  border-radius: var(--component_IngredientGroupDisplay_inner_border-radius);
  width: var(--component_IngredientGroupDisplay_inner_width);
  height: var(--component_IngredientGroupDisplay_inner_height);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--component_IngredientGroupDisplay_inner_font-size);
  border: var(--component_IngredientGroupDisplay_inner_border);
  margin-right: 5px;
  padding: var(--component_IngredientGroupDisplay_inner_padding);
}
.outer {
  display: flex;
  flex-direction: row;
  line-height: 20px;
  align-content: center;
}
</style>
